<mat-slide-toggle (change)="toggleEffectTree()" checked>Show Effect Tree</mat-slide-toggle>
<div class="editor-container ignore-theme" [ngClass]="{'hidden-tree' : !showEffectTree}">
  <!-- automation tree: easy to scroll through list of effects -->
  <div class="automation-tree" *ngIf="showEffectTree">
    <div class="editor-header">
      <span class="editor-header-text">Effect Tree</span>
      <span class="toolbar-spacer"></span>
      <span>
        <button mat-icon-button matTooltip="Expand All" (click)="treeControl.expandAll()">
          <mat-icon>expand</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Collapse All" (click)="treeControl.collapseAll()">
          <mat-icon>compress</mat-icon>
        </button>
      </span>
    </div>

    <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <cdk-nested-tree-node *cdkTreeNodeDef="let node"
                            class="tree-node"
                            [class.tree-node-active]="node === selectedEffectNode">
        <span [matTooltip]="node.tooltip">
          <!-- icon -->
          <span *ngIf="node.icon">
            <!-- for some reason I can't replicate the styling of this button so we just use a disabled button -->
            <button mat-icon-button disabled>
              <mat-icon class="node-icon" [svgIcon]="node.icon" *ngIf="node.icon.includes('ddb:')"></mat-icon>
              <mat-icon class="node-icon" *ngIf="!node.icon.includes('ddb:')">{{node.icon}}</mat-icon>
            </button>
          </span>
          <!-- for nodes representing effects (AutomationEffectTreeNode) -->
          <span *ngIf="isEffectNode(node)" (click)="beginEditEffectNode(node)" class="edit-node">
            {{node.label}}
            <button mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
          </span>
          <!-- Otherwise, just display the label -->
          <span *ngIf="!isEffectNode(node)">
            {{node.label}}
          </span>
          <!-- for AutomationAddEffectNode -->
          <span *ngIf="isAddEffectNode(node)">
            <avr-new-effect-button [context]="node.context" (created)="onNewEffectCreated(node)"></avr-new-effect-button>
          </span>
        </span>
        <!-- for nodes with children -->
        <span *ngIf="hasChild(node)">
          <button mat-icon-button (click)="toggleNode(node, $event)">
            <mat-icon>
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
        </span>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" class="tree-children-container">
          <ng-container cdkTreeNodeOutlet></ng-container>
        </div>
      </cdk-nested-tree-node>
    </cdk-tree>
  </div> <!-- </automation-tree> -->

  <!-- node editor: individual node editing -->
  <div class="node-editor">
    <div *ngIf="!selectedEffectNode">
      <div class="editor-header">
        <span class="editor-header-text">Node Editor</span>
      </div>
      No node selected. Select an automation effect node from the Effect Tree to edit it!
    </div>
    <div *ngIf="selectedEffectNode">
      <avr-effect-editor [effectNode]="selectedEffectNode"
                         [spell]="spell"
                         [debugMode]="debugMode"
                         (changed)="changed.emit()"
                         (treeChanged)="refreshTree()"
                         (deleted)="selectedEffectNode = null">
      </avr-effect-editor>
    </div>
  </div> <!-- </node-editor> -->
</div>

